<div
  class="wrapper"
  [class.disabled-control]="isEdit && !isEditable"
>
  @if (isPossibleToEdit()) {
    <input
      #timeInput
      matInput
      [(ngModel)]="value"
      [matTimepicker]="picker"
      [required]="required"
      (input)="handleInputChange($event, picker)"
      (blur)="handleDateInputChange($event, picker)"
      placeholder="ЧЧ:ММ"
    >
    <div class="toggle">
      <mat-timepicker-toggle
        matIconSuffix
        [for]="picker"
      ></mat-timepicker-toggle>
    </div>
    <mat-timepicker #picker interval="15min"></mat-timepicker>
  } @else {
    <input
      matInput
      disabled
      class="none-pointer-events"
      [value]="value"
      [matTimepicker]="picker"
    >
    <mat-timepicker #picker></mat-timepicker>
  }
</div>
